<template>
    <div>
        <el-button v-on:click="backHistory">返回</el-button>
        <div class="infoDetailBox">
            <div>消息标题1:
                <span class="jlSpan">{{ list.title }}</span>
            </div>
        </div>
        <div class="infoDetailBox">
            <div>推送时间:
                <span class="jlSpan">{{ list.notification_time }}</span>
            </div>
        </div>
        <div class="infoDetailBox">
            <div>推送类型:
                <span class="jlSpan">{{ list.type | statusType }}</span>
            </div>
        </div>
        <div class="infoDetailBox">
            <div>是否推送android:
                <span class="jlSpan">{{ list.send_android }}</span>
            </div>
        </div>
        <div class="infoDetailBox">
            <div>推送ID:
                <span class="jlSpan">{{ list.jump_id }}</span>
            </div>
        </div>
        <div class="infoDetailBox">
            <div>推送状态:
                <span class="jlSpan">{{ list.status | statusFilterType }}</span>
            </div>
        </div>
        <div class="infoDetailBox">
            <div>推送用户:
                <span class="jlSpan">{{ list.system_type | statusFilterName }}</span>
            </div>
        </div>
        <div class="infoDetailBox">
            <div>详情介绍:
                <span class="jlSpan">{{ list.text }}</span>
            </div>
        </div>
    </div>
</template>
<script>
import Tinymce from "../../components/Tinymce/index";
import { messageList, messageSave, messageDelete, messageDels,notificationDetail } from "../../api/message/message";
import Upload from "../../components/File/Upload.vue";
const formJson = {



};
export default {
    inject:['reload'],
    data() {
        return {
            lists:"",
            query: {
                name: "",
                page: 1,
                time:'',
                notification_id:''
            },
            channelListInput: "",
            androidVersionListInput: "",
            iosVersionListInput: "",
            list: [],
            total: 0,
            loading: true,
            index: null,
            formName: null,
            formMap: {
                add: "新增",
                edit: "编辑"
            },
            formLoading: false,
            formVisible: false,
            formVisibleSee: false,
            formData: formJson,
            formRules: {
                title: [
                    {
                        required: true,
                        message: "请输入标题",
                        trigger: "blur"
                    }
                ]

            },
            deleteLoading: false,
            multipleSelection:[]
        };
    },
    components: {
        Upload,
        Tinymce
    },
    comments: {
            Tinymce
        },
    methods: {
        //重置
        reset(){
            this.query.time ='';
            this.query.name='';
            this.query.page=1;
            // 刷新数据
            this.getList();
        },
        backHistory(){
            this.$router.go(-1);//返回上一层
        },
        toggleSelect(rows) {
        if (rows) {
            rows.forEach(row => {
                this.$refs.multipleTable.toggleRowSelection(row, !this.allSelect)
            })
            this.allSelect = !this.allSelect
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 删除选中的
        deleteSelect(){
            this.$confirm("确认删除该记录吗?", "提示", {
                    type: "warning"
                })
                    .then(() => {
                        var notification_id_arr = [];
                        this.multipleSelection.forEach(row => {
                            notification_id_arr.push(row.notification_id)
                        })
                        let para = { notification_id_arr: notification_id_arr };
                        this.deleteLoading = true;
                        messageDelete(para)
                            .then(response => {
                                this.deleteLoading = false;
                                if (response.code!==0) {
                                    this.$message.error(response.msg);
                                    return false;
                                } else {
                                    this.$message.success("删除成功");
                                    this.reload();
                                    // 刷新数据
                                    this.getList();
                                }
                            })
                            .catch(() => {
                                this.deleteLoading = false;
                            });
                    })
                    .catch(() => {
                        this.$message.info("取消删除");
                    });
        },

        onReset() {
            this.$router.push({
                path: ""
            });
            this.query = {
                title: "",
                page: 1,
                limit: 20
            };
            this.getList();
        },
        onSubmit() {
            this.$router.push({
                path: "",
                query: this.query
            });
            this.getList();
        },
        handleSizeChange(val) {
            this.query.limit = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.query.page = val;
            this.getList();
        },
        getList() {
            this.loading = true;
            notificationDetail(this.query)
                .then(response => {
                    console.log(response,'1111111111');
                    this.loading = false;
                    this.list = response.data || [];
                    console.log(this.list,'222222222');
                })
                .catch(() => {
                    this.loading = false;
                    this.list = [];
                    this.total = 0;
                });
        },
        // 删除渠道
        handleChannelListClose(index) {
            // 更改值
            this.formData.channel_list.splice(index, 1);
        },
        // 添加渠道白名单
        handleChannelListSubmit() {
            // 更改值
            if (
                this.channelListInput &&
                this.formData.channel_list.length < 15
            ) {
                let arr = this.channelListInput.split(",");
                for (let i in arr) {
                    if (
                        arr[i] !== "" &&
                        (this.formData.channel_list.length === 0 ||
                            this.formData.channel_list.indexOf(arr[i]) < 0)
                    ) {
                        this.formData.channel_list.push(arr[i]);
                    }
                }
                this.channelListInput = "";
                this.$refs.channelListRef.focus();
            }
        },
        // 删除Android版本
        handleAndroidVersionListClose(index) {
            // 更改值
            this.formData.android_version_list.splice(index, 1);
        },
        // 添加Android版本
        handleAndroidVersionListSubmit() {
            // 更改值
            if (
                this.androidVersionListInput &&
                this.formData.android_version_list.length < 15
            ) {
                let arr = this.androidVersionListInput.split(",");
                for (let i in arr) {
                    let avList = this.formData.android_version_list;
                    if (
                        arr[i] !== "" &&
                        (avList.length === 0 || avList.indexOf(arr[i]) < 0)
                    ) {
                        this.formData.android_version_list.push(arr[i]);
                    }
                }
                this.androidVersionListInput = "";
                this.$refs.androidVersionListRef.focus();
            }
        },
        // 删除Ios版本
        handleIosVersionListClose(index) {
            // 更改值
            this.formData.ios_version_list.splice(index, 1);
        },
        // 添加Ios版本
        handleIosVersionListSubmit() {
            // 更改值
            if (
                this.iosVersionListInput &&
                this.formData.ios_version_list.length < 15
            ) {
                let arr = this.iosVersionListInput.split(",");
                for (let i in arr) {
                    if (
                        arr[i] !== "" &&
                        (this.formData.ios_version_list.length === 0 ||
                            this.formData.ios_version_list.indexOf(arr[i]) < 0)
                    ) {
                        this.formData.ios_version_list.push(arr[i]);
                    }
                }
                this.iosVersionListInput = "";
                this.$refs.iosVersionListRef.focus();
            }
        },
        // 刷新表单
        resetForm() {
            if (this.$refs["dataForm"]) {
                // 清空字段
                this.$refs["dataForm"].resetFields();
                // 清空验证信息表单
                this.$refs["dataForm"].clearValidate();
            }
        },
        // 隐藏表单
        hideForm() {
            // 更改值
            this.formVisible = !this.formVisible;
            // 清空表单
            this.$refs["dataForm"].resetFields();
            //清空富文本
            //this.$refs.tinymce.clearContent();
            let vm = this;
            setTimeout(function () {
                vm.$nextTick(() => {
                    if (vm.$refs.tinymce) {
                        vm.$refs.tinymce.setContent(
                            ''
                        );
                    }
                });
            }, 300);
        },
        // 显示表单
        handleForm(index, row) {
            this.formVisible = true;
            this.formData = Object.assign({}, formJson);
            if (row !== null) {
                this.formData = Object.assign({}, row);
            }
            this.formName = "add";
            //编辑
            if (index !== null) {
                this.imageUrl = row.img;
                this.index = index;
                this.formData.notification_id = index;
                this.formName = "edit";
                let vm = this;
                setTimeout(function () {
                    vm.$nextTick(() => {
                        if (vm.$refs.tinymce) {
                            vm.$refs.tinymce.setContent(
                                row.content
                            );
                        }
                    });
                }, 500);
            }
            // 清空验证信息表单
            if (this.$refs["dataForm"]) {
                this.$refs["dataForm"].clearValidate();
            }
        },
        formSubmit() {
            this.$refs["dataForm"].validate(valid => {
                if (valid) {
                    this.formLoading = true;
                    let data = Object.assign({}, this.formData);
                    messageSave(data, this.formName)
                        .then(response => {
                            this.formLoading = false;
                            if (response.code!==200) {
                                this.$message.error(response.msg);
                                return false;
                            }
                            this.$message.success("操作成功");
                            this.getList();
                            this.formVisible = false;
                            // if (this.formName === "add") {
                            //     // 向头部添加数据
                            //     data.ad_id = response.data.ad_id;
                            //     this.list.unshift(data);
                            // } else {
                            //     this.list.splice(this.index, 1, data);
                            // }
                        })
                        .catch(() => {
                            this.formLoading = false;
                        });
                }
            });
        },
        handleFormSee(index,row) {
            this.$router.push({ path: `/findManage/findList/find_id/${row}` })
        },
        // 删除
        handleDel(index, row) {

            if (row) {
                this.$confirm("确认删除该记录吗?", "提示", {
                    type: "warning"
                })
                    .then(() => {
                        var notification_id_arr = [];
                        notification_id_arr.push(row)
                        let para = { notification_id_arr: notification_id_arr };
                        this.deleteLoading = true;
                        messageDelete(para)
                            .then(response => {
                                this.deleteLoading = false;
                                if (response.message !== "success") {
                                    this.$message.error(response.msmessageg);
                                    return false;
                                } else {
                                    this.$message.success("删除成功");
                                    this.reload();
                                    this.data.splice(index, 1);
                                    this.getList();
                                }
                            })
                            .catch(() => {
                                this.deleteLoading = false;
                            });
                    })
                    .catch(() => {
                        this.$message.info("取消删除");
                    });
            }
        },
        onSelectPic(filePath, filePathUrl) {
            this.formData.pic = filePath;
            this.formData.pic_url = filePathUrl;
        }
    },
    filters: {
        statusFilterType(status) {
            const statusMap = {
                1: "已推送",
                0: "未推送"
            };
            return statusMap[status];
        },
        statusType(status) {
            const statusMap = {
                6: "系统消息",
                8: "文章群发",
                10: "个人页面群发"
            };
            return statusMap[status];
        },
        statusFilterName(status) {
            const statusMap = {
                0: "全部用户",
                1: "普通",
                2: "认证",
                3: "Pro"
            };
            return statusMap[status];
        }
    },
    mounted() {},
    created() {
        // 将参数拷贝进查询对象
        let query = this.$route.query;
        console.log(query);
        this.query.notification_id = query.notification_id;
        // this.query = Object.assign(this.query, query);
        // this.query.limit = parseInt(this.query.limit);
        // 加载表格数据
        this.getList();
    }
};
</script>

<style type="text/scss" lang="scss">
</style>
